import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const solutions = [
  {
    id: 'itsm',
    icon: 'ri-customer-service-2-line',
    badge: 'ManageEngine',
    title: 'ITSM — ServiceDesk Plus',
    desc: 'Ticketing, CMDB, SLA ve problem/değişiklik yönetimini tek platformda birleştiren kurumsal IT servis masası çözümü.',
    features: ['Ticketing & CMDB', 'SLA & Problem Yönetimi', 'Self-Servis Portal', 'Raporlama & Analitik'],
    cta: 'ServiceDesk Plus Danışmanlığı',
    color: '#0891B2',
    image: 'https://public.readdy.ai/ai/img_res/a62dc4d697735feb6abab77442b7305a.jpg',
  },
  {
    id: 'uem',
    icon: 'ri-computer-line',
    badge: 'ManageEngine',
    title: 'UEM — Endpoint Central',
    desc: 'Tüm uç noktaları merkezi olarak yönetin: patch, yazılım dağıtımı, envanter takibi ve güvenlik uyumluluğu.',
    features: ['Patch Yönetimi', 'Yazılım Dağıtımı', 'Güvenlik & Compliance', 'Uzak Masaüstü'],
    cta: 'Endpoint Central Kurulumu',
    color: '#F97316',
    image: 'https://readdy.ai/api/search-image?query=Professional%20endpoint%20management%20dashboard%20on%20bright%20monitor%20showing%20device%20inventory%20list%20with%20laptop%20mobile%20tablet%20icons%2C%20patch%20compliance%20percentage%20chart%20circular%20gauge%2C%20software%20deployment%20status%20progress%20bars%2C%20security%20risk%20score%20dashboard%2C%20clean%20white%20light%20gray%20UI%20design%20with%20orange%20amber%20accent%20elements%2C%20modern%20enterprise%20security%20platform%20screenshot&width=700&height=440&seq=sol-uem-light-01&orientation=landscape',
  },
  {
    id: 'ad',
    icon: 'ri-shield-user-line',
    badge: 'ManageEngine',
    title: 'Active Directory Yönetimi',
    desc: 'ADManager Plus ve ADAudit Plus ile kullanıcı erişim yönetimini ve güvenlik denetimini otomatikleştirin.',
    features: ['ADManager Plus', 'ADAudit Plus', 'Kullanıcı Yönetimi', 'Erişim Denetimi'],
    cta: 'AD Yönetim Danışmanlığı',
    color: '#0891B2',
    image: 'https://readdy.ai/api/search-image?query=Active%20Directory%20user%20management%20interface%20on%20bright%20computer%20screen%20showing%20organizational%20hierarchy%20tree%20diagram%2C%20permission%20matrix%20table%20with%20access%20roles%2C%20user%20account%20list%20with%20status%20indicators%2C%20audit%20log%20timeline%20events%20panel%2C%20clean%20white%20background%20with%20teal%20blue%20accent%20highlights%2C%20professional%20enterprise%20identity%20management%20software%2C%20modern%20light%20UI%20screenshot&width=700&height=440&seq=sol-ad-light-01&orientation=landscape',
  },
  {
    id: 'monitor',
    icon: 'ri-line-chart-line',
    badge: 'ManageEngine',
    title: 'IT Operations Monitoring',
    desc: 'Sunucu, cihaz ve ağ altyapınızı proaktif olarak izleyin. Alarmları önceden tespit edip müdahale edin.',
    features: ['Sunucu & Ağ İzleme', 'Alarm & Performans', 'Log Analizi', 'Dashboard & Raporlar'],
    cta: 'Monitoring Çözümleri Hakkında',
    color: '#F97316',
    image: 'https://readdy.ai/api/search-image?query=IT%20infrastructure%20monitoring%20dashboard%20on%20bright%20screen%20showing%20server%20performance%20line%20charts%20in%20green%20blue%20colors%2C%20network%20topology%20map%20with%20status%20indicators%2C%20alert%20notification%20panel%20with%20warning%20icons%2C%20real-time%20metrics%20widgets%20CPU%20memory%20disk%20usage%2C%20clean%20white%20light%20gray%20background%20professional%20NOC%20operations%20dashboard%2C%20modern%20enterprise%20monitoring%20software%20UI%20screenshot&width=700&height=440&seq=sol-monitor-light-01&orientation=landscape',
  },
  {
    id: 'automate',
    icon: 'ri-robot-2-line',
    badge: 'AutomMate',
    title: 'Otomasyon & Entegrasyon',
    desc: 'No-code/low-code süreç otomasyonları, API entegrasyonları, IoT tetikleyiciler ve RPA-lite Python botları.',
    features: ['No-code Otomasyon', 'API Entegrasyonları', 'IoT & Trigger Tabanlı', 'RPA-lite Python Botları'],
    cta: 'Süreç Otomasyonu Danışmanlığı',
    color: '#0891B2',
    image: 'https://readdy.ai/api/search-image?query=No-code%20business%20process%20automation%20workflow%20builder%20on%20bright%20clean%20screen%2C%20drag%20and%20drop%20flowchart%20diagram%20with%20connected%20nodes%20showing%20automation%20steps%2C%20API%20integration%20panel%20with%20service%20connection%20cards%2C%20trigger%20condition%20settings%2C%20clean%20white%20minimal%20interface%20with%20teal%20cyan%20workflow%20connector%20lines%2C%20modern%20SaaS%20automation%20platform%20UI%20screenshot%20on%20computer&width=700&height=440&seq=sol-auto-light-01&orientation=landscape',
  },
  {
    id: 'zoho',
    icon: 'ri-apps-line',
    badge: 'Zoho ONE',
    title: 'Zoho ONE Entegrasyon',
    desc: 'CRM, satış, finans ve operasyon yönetimini IT çözümlerinizle entegre ederek uçtan uca iş akışı oluşturun.',
    features: ['CRM & Satış', 'Finans & Operasyon', 'Süreç Akışları', 'IT Entegrasyonu'],
    cta: 'Zoho ONE Implementasyonu',
    color: '#F97316',
    image: 'https://readdy.ai/api/search-image?query=Zoho%20ONE%20business%20suite%20dashboard%20on%20bright%20professional%20screen%20showing%20CRM%20sales%20pipeline%20kanban%20board%20with%20deal%20stage%20cards%2C%20revenue%20chart%20bar%20graph%2C%20operations%20workflow%20status%2C%20module%20icons%20grid%20for%20different%20business%20apps%2C%20clean%20white%20background%20with%20warm%20orange%20accent%20elements%2C%20modern%20enterprise%20SaaS%20platform%20UI%20screenshot%2C%20professional%20business%20software%20design&width=700&height=440&seq=sol-zoho-light-01&orientation=landscape',
  },
];

const Solutions = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from('.sol-header', { scrollTrigger: { trigger: '.sol-header', start: 'top 85%' }, opacity: 0, y: 30, duration: 0.9, ease: 'power3.out' });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  const sol = solutions[activeTab];

  return (
    <section ref={sectionRef} id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="sol-header text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#ECFEFF] border border-[#0891B2]/30 text-[#0E7490] text-xs font-semibold mb-5 font-body">
            <i className="ri-grid-line"></i>
            Çözümlerimiz
          </div>
          <h2 className="text-4xl font-extrabold text-[#0F172A] mb-4 font-heading leading-tight">
            IT Ekosisteminizi Güçlendiren<br />
            <span className="text-[#0891B2]">Entegre Çözümler</span>
          </h2>
          <p className="text-base text-[#475569] max-w-xl mx-auto font-body">
            ManageEngine, AutomMate ve Zoho ONE platformlarında uçtan uca uzman danışmanlık.
          </p>
        </div>

        {/* Tab selector */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {solutions.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setActiveTab(i)}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap font-body border ${
                activeTab === i
                  ? 'bg-[#0891B2] text-white border-[#0891B2]'
                  : 'bg-white text-[#475569] border-[#E2E8F0] hover:border-[#0891B2]/40 hover:text-[#0891B2]'
              }`}
            >
              <i className={`${s.icon} text-base`}></i>
              {s.title.split(' — ')[0].replace('ITSM', 'ITSM').replace('UEM', 'UEM')}
            </button>
          ))}
        </div>

        {/* Active solution card */}
        <div key={sol.id} className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center p-8 md:p-10 rounded-2xl bg-[#F8FAFC] border border-[#E2E8F0]" style={{ animation: 'fadeIn 0.4s ease-out' }}>
          <div>
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold mb-4 font-body" style={{ background: `${sol.color}15`, color: sol.color, border: `1px solid ${sol.color}30` }}>
              <i className={sol.icon}></i>
              {sol.badge}
            </div>
            <h3 className="text-2xl font-extrabold text-[#0F172A] mb-3 font-heading">{sol.title}</h3>
            <p className="text-sm text-[#475569] leading-relaxed mb-6 font-body">{sol.desc}</p>

            <ul className="space-y-3 mb-8">
              {sol.features.map((f, j) => (
                <li key={j} className="flex items-center gap-3 text-sm text-[#334155] font-body">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0" style={{ background: `${sol.color}20` }}>
                    <i className="ri-check-line text-xs" style={{ color: sol.color }}></i>
                  </div>
                  {f}
                </li>
              ))}
            </ul>

            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-lg text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap font-body hover:scale-105"
              style={{ background: sol.color, color: '#fff' }}
            >
              {sol.cta}
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="rounded-xl overflow-hidden border border-[#E2E8F0]">
            <img
              src={sol.image}
              alt={sol.title}
              title={sol.title}
              className="w-full h-64 object-cover object-top"
            />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </section>
  );
};

export default Solutions;
